// extracted by mini-css-extract-plugin
module.exports = {"LoadingLogo":"AppLoader_LoadingLogo__2qAeV","bubbling":"AppLoader_bubbling__FbVUp"};